/* eslint no-unused-vars: "off" */
import 'swiper/src/less/swiper.less';
import './slider.less';

window.addEventListener('load', () => {
  const swiperContext = require('bundle-loader?name=slider!Swiper');

  swiperContext((Swiper) => {
    const admissionSlider = new Swiper('.swiper-container.c-admission-slider__container', {
      effect: 'fade',
      simulateTouch: false,
      pagination: '.swiper-pagination',
      paginationClickable: true,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
    });
  });
});


// WEBPACK FOOTER //
// ./src/pages/admission/slider/index.js